/**
 * StageEditor — the pipeline Stage editor panel (SE-5488): rename, reorder, add,
 * remove stages + edit their protected/terminal flags, with the delete guards
 * (block-on-cards, warn-and-pause-rules). Mounted once; opened via the toolbar
 * StageEditorButton (which drives the editor reactive var).
 * @module features/player-kanban/components/organisms/StageEditor
 */

export { default } from "./StageEditorContainer";
